import React, { useEffect, useState } from 'react';
import { appGetLocale, appPathPrefix, isMobileAspectRatio } from '../helpers/appHelper';
import { FormattedMessage } from 'react-intl';
import { getShops } from '../apis';
import Footer from '../components/Footer';
import { yamazaki_brown } from '../styles/color';

const Shops = () => {
    const appLanguage = appGetLocale();
    const isEng = appLanguage === 'en';
    const [shops, setShops] = useState([]);
    const [district, setDistrict] = useState([]);
    const [showAreaSelect, setShowAreaSelect] = useState(false);
    const [showDistrictSelect, setShowDistrictSelect] = useState(false);
    const [selectedArea, setSelectedArea] = useState('');
    const [selectedDistrict, setSelectedDistrict] = useState('');
    const [searchText, setSearchText] = useState('');
    const [delayedSearchText, setDelayedSearchText] = useState('');
    const isMobile = isMobileAspectRatio();
    const prefix = appPathPrefix();

    useEffect(() => {
        getData();
    }, []);

    useEffect(() => {
        setShowDistrictSelect(selectedArea !== '');
        setSelectedDistrict('');
    }, [selectedArea]);

    useEffect(() => {
        const handler = setTimeout(() => {
            setDelayedSearchText(searchText);
        }, 500);

        return () => clearTimeout(handler);
    }, [searchText]);

    const handleAreaSelect = (value) => {
        if (value === selectedArea) {
            setSelectedArea('');
            return;
        }
        setSelectedArea(value);
    };

    const getData = async () => {
        const shop_result = await getShops();
        if (!shop_result.fail) {
            setShops(shop_result.shops);
            setDistrict(shop_result.regions);
        }
    };

    const NavBar = () => (
        <div className="shops-nav">
            <a href={prefix + "/"} style={{ color: yamazaki_brown, textDecoration: 'none' }}>
                <span>
                    <FormattedMessage id={'menus.home'} />
                </span>
            </a>
            <span> {">"} </span>
            <span style={{ fontWeight: 'bold' }}>
                <FormattedMessage id={'menus.shops'} />
            </span>
        </div>
    );

    const FilterList = () => {
        return (
            <div className="shops-filter-list">
                <div
                    className="shops-filter-area"
                    onMouseEnter={() => setShowAreaSelect(true)}
                    onMouseLeave={() => { if (selectedArea === '') setShowAreaSelect(false) }}
                    onClick={() => setShowAreaSelect(true)}
                >
                    {isEng ?
                        <img src='./images/stores_area_en.png' />
                        :
                        <img src='./images/stores_area.png' />
                    }
                    {showAreaSelect && (
                        <div className="shops-filter-area-select-box">
                            {
                                district.map((item, index) => (
                                    <div
                                        key={index}
                                        className={`shops-filter-area-select-box-item ${selectedArea === item.city_code ? 'selected' : ''}`}
                                        onClick={() => handleAreaSelect(item.city_code)}
                                    >
                                        {isEng ? item.city_name_en : item.city_name_tc}
                                    </div>
                                ))
                            }
                        </div>
                    )}
                </div>
                <div className="shops-filter-district">
                    {isEng ?
                        <img src='./images/stores_district_en.png' />
                        :
                        <img src='./images/stores_district.png' />
                    }
                    {showDistrictSelect &&
                        <div className="shops-filter-district-block" />
                    }
                    {showDistrictSelect && (
                        <div className="shops-filter-district-select-box">
                            {
                                district.find(item => item.city_code === selectedArea)?.districts?.map((item, index) => (
                                    <div
                                        key={index}
                                        className={`shops-filter-district-select-box-item ${selectedDistrict === item.district_code ? 'selected' : ''}`}
                                        onClick={() => setSelectedDistrict(selectedDistrict === item.district_code ? '' : item.district_code)}
                                        style={{ fontSize: isEng ? (isMobile?'min(1.5vw,1.5em)':'min(1.3vw,1.3em)') : (isMobile?'min(2vw,2em)':'min(1.6vw,1.6em)'), letterSpacing: isEng ? '0' : '0.2vw', fontWeight: (isEng&&isMobile)?'bold':'normal' }}
                                    >
                                        {isEng ? item.district_name_en : item.district_name_tc}
                                    </div>
                                ))
                            }
                            {district.find(item => item.city_code === selectedArea)?.districts?.length % 4 !== 0 &&
                                Array.from({ length: 4 - (district.find(item => item.city_code === selectedArea)?.districts?.length % 4) }).map((_, index) => (
                                    <div key={`empty-${index}`} className="shops-filter-district-select-box-item empty" />
                                ))
                            }
                        </div>
                    )}
                </div>
            </div>
        );
    }

    const ShopList = () => {
        const [selectedShop, setSelectedShop] = useState(shops);
        const [showMap, setShowMap] = useState(false);
        const [mapEmbedHtml, setMapEmbedHtml] = useState('');

        useEffect(() => {
            const new_list = shops.filter(shop => {
                const search_text = delayedSearchText?.toLowerCase()?.replaceAll(' ', '');
                const matchesSearchText = (shop.address_tc?.toLowerCase()?.replaceAll(' ', '').indexOf(search_text) > -1)
                    || (shop.address_en?.toLowerCase()?.replaceAll(' ', '').indexOf(search_text) > -1)
                    || (shop.name_tc?.toLowerCase()?.replaceAll(' ', '').indexOf(search_text) > -1)
                    || (shop.name_en?.toLowerCase()?.replaceAll(' ', '').indexOf(search_text) > -1)
                    || (shop.phone?.toLowerCase()?.replaceAll(' ', '').indexOf(search_text) > -1);

                if (selectedArea !== '' && selectedDistrict !== '') {
                    return shop.region.city_code === selectedArea && shop.region.district_code === selectedDistrict && matchesSearchText;
                } else if (selectedArea !== '') {
                    return shop.region.city_code === selectedArea && matchesSearchText;
                } else {
                    return matchesSearchText;
                }
            });
            if (new_list !== selectedShop) setSelectedShop(new_list);
        }, [selectedArea, selectedDistrict, delayedSearchText, shops]);

        return (
            <div className="shops-shop-list">
                {selectedShop.map((shop, index) => (
                    isMobile?
                    <div key={index} className="shops-shop-item" onClick={() => { setShowMap(true); setMapEmbedHtml(shop.web_map_embed_html); }}>
                        <div className="shops-shop-item-name">
                            {isEng ? shop.name_en : shop.name_tc}
                        </div>
                        <div style={{ display: 'flex', flexDirection: 'row' }}>
                            <div className="shops-shop-item-shop">
                                <div style={{position:'relative'}}>
                                    <img className="shops-shop-item-shop-photo" src={shop.image_url} />
                                    <div className="shops-shop-item-shop-location" style={{ fontSize: 'min(2.5vw, 2.5em)' }}>
                                        <img src='./images/icon_pin.png' style={{ marginRight: '0.5vw', width: '70%' }} />
                                        <FormattedMessage id={'shops.showLocation'} />
                                    </div>
                                </div>
                                <div className="shops-shop-item-info-cake-bake">
                                    {(shop.cake_shop === 'Y' || shop.bake_shop === 'Y') && <><FormattedMessage id={'shops.cakeAndBake'} />&nbsp;&nbsp;</>}
                                    {shop.cake_shop === 'Y' && <img src='./images/icon_cake.png' />}
                                    {shop.bake_shop === 'Y' && <img src='./images/icon_bakery.png' />}
                                </div>
                            </div>
                            <div className="shops-shop-item-info">
                                <div className="shops-shop-item-info-address">
                                    <img src='./images/icon_pin.png' />
                                    {isEng ? shop.address_en : shop.address_tc}
                                </div>
                                <div className="shops-shop-item-info-phone">
                                    <img src='./images/icon_phone.png' />
                                    {shop.phone}
                                </div>
                                <div className="shops-shop-item-info-opening-hours">
                                    <img src='./images/icon_time.png' />
                                    <div className="shops-shop-item-info-opening-hours-item">
                                        {shop.opening_hours.map((item, index) => (
                                            <span key={index}>{item.text}</span>
                                        ))}
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                    :
                    <div key={index} className="shops-shop-item" onClick={() => { setShowMap(true); setMapEmbedHtml(shop.web_map_embed_html); }}>
                        <div className="shops-shop-item-name" style={{ fontSize: isEng ? 'min(1.3vw, 1.3em)' : 'min(1.6vw, 1.6em)', letterSpacing: isEng ? '0' : '0.3vw' }}>
                            {isEng ? shop.name_en : shop.name_tc}
                        </div>
                        <div className="shops-shop-item-shop">
                            <img className="shops-shop-item-shop-photo" src={shop.image_url} />
                            <div className="shops-shop-item-shop-location" style={{ fontSize: isEng ? 'min(1.5vw, 1.5em)' : 'min(2vw, 1.7em)' }}>
                                <img src='./images/icon_pin.png' style={{ marginRight: '0.5vw' }} />
                                <FormattedMessage id={'shops.showLocation'} />
                            </div>
                        </div>
                        <div className="shops-shop-item-info">
                            <div className="shops-shop-item-info-address" style={{ fontSize: isEng ? 'min(1.2vw, 1.2em)' : 'min(1.5vw, 1.1em)' }}>
                                <img src='./images/icon_pin.png' />
                                {isEng ? shop.address_en : shop.address_tc}
                            </div>
                            <div className="shops-shop-item-info-phone" style={{ fontSize: isEng ? 'min(1.2vw, 1.2em)' : 'min(1.5vw, 1.1em)' }}>
                                <img src='./images/icon_phone.png' />
                                {shop.phone}
                            </div>
                            <div className="shops-shop-item-info-opening-hours" style={{ fontSize: isEng ? 'min(1.2vw, 1.2em)' : 'min(1.5vw, 1.1em)' }}>
                                <img src='./images/icon_time.png' />
                                <div className="shops-shop-item-info-opening-hours-item">
                                    {shop.opening_hours.map((item, index) => (
                                        <span key={index}>{item.text}</span>
                                    ))}
                                </div>
                            </div>
                            <div className="shops-shop-item-info-cake-bake" style={{ fontSize: isEng ? 'min(1.2vw, 1.2em)' : 'min(1.5vw, 1.1em)' }}>
                                {<div style={{opacity: (shop.cake_shop === 'Y' || shop.bake_shop === 'Y')?1:0}}>
                                    <FormattedMessage id={'shops.cakeAndBake'} />&nbsp;&nbsp;
                                </div>}
                                {shop.cake_shop === 'Y' && <img src='./images/icon_cake.png' />}
                                {shop.bake_shop === 'Y' && <img src='./images/icon_bakery.png' />}
                            </div>
                        </div>
                    </div>
                ))}
                {showMap && (
                    <div className="map-popup">
                        <div className="map-popup-overlay" onClick={() => setShowMap(false)}></div>
                        <div className="map-popup-content" dangerouslySetInnerHTML={{ __html: mapEmbedHtml }} />
                    </div>
                )}
            </div>
        );
    }

    return (
        <div className='shops'>
            <div className="shops-background">
                <img src='./images/shops_background.png' />
                <span className="shops-title" style={{ letterSpacing: isEng?'0':'1.5vw' }}>
                    <FormattedMessage id={'shops.title'} />
                </span>
            </div>
            { isMobile ?
            <>
                <NavBar /> 
                <div className="shops-search-bar-and-icon-container">
                    <div className="shops-search-bar">
                        <input
                            type="search"
                            placeholder={isEng ? "Search" : "店鋪搜尋"}
                            onChange={(e) => setSearchText(e.target.value)}
                            value={searchText}
                            ref={input => input && input.focus()}
                        />
                        <img src='./images/search.png' />
                    </div>
                    {isEng ?
                        <div className='shops-icon-container'>
                            <img src='./images/stores_cake_en.png' />
                            <img src='./images/stores_bakery_en.png' style={{ transform: 'scale(0.9)' }}/>
                        </div>
                        :
                        <div className='shops-icon-container'>
                            <img src='./images/stores_cake.png' />
                            <img src='./images/stores_bakery.png' />
                        </div>
                    }
                </div>
            </> 
            :
            <div className="shops-search-bar-and-icon-container">
                {isEng ?
                    <>
                        <img src='./images/stores_cake_en.png' />
                        <img src='./images/stores_bakery_en.png' style={{ marginLeft: 'min(5vw,5em)', transform: 'scale(0.9)' }} />
                    </>
                    :
                    <>
                        <img src='./images/stores_cake.png' />
                        <img src='./images/stores_bakery.png' style={{ marginLeft: 'min(5vw,5em)' }} />
                    </>
                }
                <div className="shops-search-bar">
                    <input
                        type="search"
                        placeholder={isEng ? "Search" : "店鋪搜尋"}
                        onChange={(e) => setSearchText(e.target.value)}
                        value={searchText}
                        ref={input => input && input.focus()}
                    />
                    <img src='./images/search.png' />
                </div>
            </div>
            }
            <FilterList />
            <ShopList />
            <Footer />
        </div>
    )
};

export default Shops;